import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './messageOptionItem.module.scss';
import checkIcon from '../../../../../globals/images/option-selected.svg';

class MessageOptionItem extends Component {
    render() {
        let { id, isHighlighted, onClick, text, index } = this.props;
        return (
            <div className={styles.row} id={`tutorial-select-option-${index}`}>
                <div className={styles.image}>
                    {isHighlighted ? <img src={checkIcon} alt="checkicon" /> : null}
                </div>
                <div
                    onClick={() => { onClick(id); }}
                    className={styles['read-text']}
                    style={isHighlighted ? { backgroundColor: '#fafaff', border: 'solid 1px #534d9a' } : {}}
                    dangerouslySetInnerHTML={{ __html: text }}
                />
            </div>
        );
    }
}

MessageOptionItem.propTypes = {};

MessageOptionItem.defaultProps = {};

export default MessageOptionItem;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/messageOptionItem/MessageOptionItem.js